export { SkyPageSummarySubtitleComponent } from './page-summary-subtitle.component';
